/**
 * The last active organisation, kept so a reload (or a later sign-in on this
 * browser) lands where an accepted invite put the person. Storage can be
 * unavailable (private mode, blocked site data): every access is guarded and a
 * failed read means "no preference".
 */

const KEY = 'px_active_org'

/** The remembered org id, or null. The caller validates it against the memberships. */
export function readActiveOrgPreference(): string | null {
  try {
    const value = window.localStorage.getItem(KEY)
    return value !== null && value !== '' ? value : null
  } catch {
    return null
  }
}

/** Remember the org id the session just selected. */
export function writeActiveOrgPreference(orgId: string): void {
  try {
    window.localStorage.setItem(KEY, orgId)
  } catch {
    // Unavailable storage: the next load falls back to the first membership.
  }
}
